import { createFileRoute, Outlet } from '@tanstack/react-router'
import { requireAnyPermission } from '../../../../app/guards'

/** Material issues and returns: who records them, or who reads project money. */
export const Route = createFileRoute('/_app/projects/material-issues')({
  staticData: { crumb: 'projectMaterialIssues' },
  beforeLoad: ({ context }) =>
    requireAnyPermission(context.session, 'projects.materials', 'projects.financials'),
  component: Outlet,
})
